import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiShoppingCart, FiAlertCircle, FiCheck, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .bp-root {
    font-family: 'Montserrat', sans-serif;
    min-height: 100vh;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
    padding: 4px 10px;
    // margin-top: 80px;
  }

  @media (min-width: 640px) {
    .bp-root {
      // padding: 48px 24px;
    }
  }

  .bp-container {
    max-width: 72rem;
    margin: 0 auto;
  }

  /* Header */
  .bp-header {
    margin-bottom: 32px;
  }

  .bp-back-btn {
    padding: 8px;
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 8px;
    transition: background 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .bp-back-btn:hover {
    background: #e5e7eb;
  }

  .bp-back-btn svg {
    font-size: 24px;
  }

  .bp-header-content {
    margin-top: 16px;
  }

  .bp-title {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
  }

  @media (min-width: 640px) {
    .bp-title {
      font-size: 30px;
    }
  }

  .bp-subtitle {
    color: #6b7280;
    margin-top: 8px;
  }

  /* Alerts */
  .bp-alert-error {
    margin-bottom: 24px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .bp-alert-error svg {
    color: #ef4444;
    flex-shrink: 0;
  }

  .bp-alert-error p {
    color: #b91c1c;
  }

  .bp-alert-success {
    margin-bottom: 24px;
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .bp-alert-success svg {
    color: #22c55e;
    flex-shrink: 0;
  }

  .bp-alert-success p {
    color: #15803d;
  }

  /* Empty Cart */
  .bp-empty {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    padding: 48px;
    text-align: center;
  }

  .bp-empty-icon {
    margin: 0 auto 16px;
    color: #9ca3af;
  }

  .bp-empty-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 8px;
  }

  .bp-empty-text {
    color: #6b7280;
    margin-bottom: 24px;
  }

  .bp-empty-btn {
    padding: 12px 24px;
    background: linear-gradient(135deg, #2563eb, #7c3aed);
    color: #ffffff;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Montserrat', sans-serif;
  }

  .bp-empty-btn:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }

  /* Cart Grid */
  .bp-cart-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;
  }

  @media (min-width: 1024px) {
    .bp-cart-grid {
      grid-template-columns: 2fr 1fr;
    }
  }

  /* Cart Items */
  .bp-items {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .bp-item {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .bp-item-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .bp-item-info {
    flex: 1;
  }

  .bp-item-name {
    font-weight: 600;
    color: #1f2937;
  }

  .bp-item-price {
    font-size: 14px;
    color: #6b7280;
  }

  .bp-item-pv {
    font-size: 14px;
    color: #6b7280;
  }

  .bp-item-qty {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bp-qty-btn {
    width: 32px;
    height: 32px;
    background: #f3f4f6;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    font-size: 16px;
  }

  .bp-qty-btn:hover {
    background: #e5e7eb;
  }

  .bp-qty-value {
    width: 32px;
    text-align: center;
    font-weight: 700;
  }

  .bp-item-total {
    text-align: right;
  }

  .bp-item-total-price {
    font-weight: 700;
    color: #1f2937;
  }

  .bp-item-remove {
    background: none;
    border: none;
    color: #ef4444;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.2s;
  }

  .bp-item-remove:hover {
    color: #b91c1c;
  }

  /* Order Panel */
  .bp-panel {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    padding: 24px;
    position: sticky;
    top: 96px;
    height: fit-content;
  }

  .bp-panel-title {
    font-size: 20px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 24px;
  }

  .bp-summary {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
  }

  .bp-summary-row {
    display: flex;
    justify-content: space-between;
  }

  .bp-summary-label {
    color: #6b7280;
  }

  .bp-summary-value {
    font-weight: 600;
  }

  .bp-summary-value-blue {
    font-weight: 700;
    color: #2563eb;
  }

  .bp-summary-value-purple {
    font-weight: 700;
    color: #7c3aed;
  }

  /* Total Box */
  .bp-total-box {
    background: linear-gradient(135deg, #2563eb, #7c3aed);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
    color: #ffffff;
  }

  .bp-total-box-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .bp-total-label {
    font-size: 14px;
    opacity: 0.9;
  }

  .bp-total-amount {
    font-size: 24px;
    font-weight: 700;
  }

  .bp-total-pv {
    text-align: right;
  }

  .bp-total-pv-label {
    font-size: 14px;
    opacity: 0.9;
  }

  .bp-total-pv-value {
    font-size: 18px;
    font-weight: 600;
  }

  /* Form */
  .bp-form-group {
    margin-bottom: 24px;
  }

  .bp-form-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
  }

  .bp-form-select {
    width: 100%;
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
    background: #ffffff;
  }

  .bp-form-select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  }

  .bp-form-input {
    width: 100%;
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
  }

  .bp-form-input:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  }

  .bp-form-textarea {
    width: 100%;
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
    resize: vertical;
  }

  .bp-form-textarea:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  }

  /* Action Buttons */
  .bp-actions {
    display: flex;
    gap: 16px;
  }

  .bp-btn-clear {
    flex: 1;
    padding: 16px 24px;
    background: #e2e8f0;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    color: #1e293b;
    cursor: pointer;
    transition: background 0.2s;
    font-family: 'Montserrat', sans-serif;
  }

  .bp-btn-clear:hover {
    background: #cbd5e1;
  }

  .bp-btn-order {
    flex: 1;
    padding: 16px 24px;
    background: linear-gradient(135deg, #2563eb, #7c3aed);
    color: #ffffff;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: 'Montserrat', sans-serif;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .bp-btn-order:hover:not(:disabled) {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }

  .bp-btn-order:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Skeleton Loading */
  .bp-skeleton {
    min-height: 100vh;
    background: #f3f4f6;
    padding: 48px 16px;
  }

  .bp-skeleton-inner {
    max-width: 72rem;
    margin: 0 auto;
  }

  .bp-skeleton-title {
    height: 48px;
    background: linear-gradient(145deg, #e5e7eb, #d1d5db);
    border-radius: 8px;
    margin-bottom: 16px;
    animation: bp-shimmer 1.4s infinite;
    background-size: 200% 100%;
  }

  .bp-skeleton-card {
    height: 256px;
    background: linear-gradient(145deg, #e5e7eb, #d1d5db);
    border-radius: 8px;
    animation: bp-shimmer 1.4s infinite;
    background-size: 200% 100%;
  }

  @keyframes bp-shimmer {
    from { background-position: -200% 0; }
    to { background-position: 200% 0; }
  }

  /* Responsive */
  @media (max-width: 640px) {
    .bp-item {
      flex-wrap: wrap;
    }

    .bp-item-image {
      width: 60px;
      height: 60px;
    }

    .bp-actions {
      flex-direction: column;
    }

    .bp-empty {
      padding: 32px 16px;
    }

    .bp-total-box-content {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    .bp-total-pv {
      text-align: left;
    }
  }
`;

const BuyProduct = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [purchasing, setPurchasing] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [mobileStores, setMobileStores] = useState([]);
  const [selectedMobileStore, setSelectedMobileStore] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [deliveryContact, setDeliveryContact] = useState("");
  const [deliveryNotes, setDeliveryNotes] = useState("");
  const [userLocation, setUserLocation] = useState({ state: "", district: "" });
  const [userProfile, setUserProfile] = useState({ mobile: "", address: "", district: "", tahsil: "", state: "", postOffice: "", pinCode: "" });

  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity, clearCart, getCartTotal, getCartPv } = useCart();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const walletResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/dashboard/member`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setWallet(walletResponse.data.wallet);

        const userResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setUserLocation({ state: userResponse.data.user.state, district: userResponse.data.user.district });
        setUserProfile({
          mobile: userResponse.data.user.mobile || "",
          address: userResponse.data.user.address || "",
          district: userResponse.data.user.district || "",
          tahsil: userResponse.data.user.tahsil || "",
          state: userResponse.data.user.state || "",
          postOffice: userResponse.data.user.postOffice || "",
          pinCode: userResponse.data.user.pinCode || ""
        });

        // Build delivery address in correct sequential order
        const addressParts = [
          userResponse.data.user.address,
          userResponse.data.user.tahsil,
          userResponse.data.user.district,
          userResponse.data.user.state,
          userResponse.data.user.pinCode
        ].filter(Boolean);

        setDeliveryAddress(addressParts.join(", "));
        setDeliveryContact(userResponse.data.user.mobile || "");

        const storesResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/product/mobile-stores`,
          {
            params: { state: userResponse.data.user.state, district: userResponse.data.user.district }
          }
        );
        setMobileStores(storesResponse.data.mobileStores || []);

        const productsResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/product/available`
        );
        setProducts(productsResponse.data.products || []);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePurchase = async () => {
    if (cartItems.length === 0) {
      setError("Your cart is empty");
      return;
    }

    for (const item of cartItems) {
      if (item.quantity < 1) {
        setError("Quantity must be at least 1 for all products");
        return;
      }
      const product = products.find(p => p._id === item.productId);
      if (product && item.quantity > product.quantity) {
        setError(`Insufficient stock for ${product.name}. Available: ${product.quantity}`);
        return;
      }
    }

    if (!selectedMobileStore) {
      setError("Please select a Mobile Store");
      return;
    }

    const totalAmount = getCartTotal(products);

    if (wallet.puapWallet < totalAmount) {
      setError(`Insufficient PU&AP Wallet balance. Required: ₹${totalAmount}, Available: ₹${wallet.puapWallet}`);
      return;
    }

    setPurchasing(true);
    setError("");

    try {
      const token = localStorage.getItem("token");
      
      const payload = {
        items: cartItems,
        paymentMethod: "wallet_puap",
        mobileStoreId: selectedMobileStore,
        deliveryAddress,
        deliveryContact,
        deliveryNotes
      };

      await axios.post(
        `${process.env.REACT_APP_API_URL}/product/purchase/${cartItems[0].productId}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setSuccess(`Order placed successfully! Total: ₹${totalAmount.toLocaleString("en-IN")}. Waiting for Mobile Store confirmation.`);
      clearCart();
      setSelectedMobileStore("");
      setDeliveryNotes("");

      // Refill delivery address and contact from user profile
      const addressParts = [
        userProfile.address,
        userProfile.district,
        userProfile.tahsil,
        userProfile.state,
        userProfile.postOffice,
        userProfile.pinCode
      ].filter(Boolean);
      setDeliveryAddress(addressParts.join(", "));
      setDeliveryContact(userProfile.mobile);

      await axios.get(
        `${process.env.REACT_APP_API_URL}/dashboard/member`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      ).then(res => setWallet(res.data.wallet));

      setTimeout(() => setSuccess(""), 5000);
    } catch (err) {
      setError(err.response?.data?.message || "Order placement failed");
    } finally {
      setPurchasing(false);
    }
  };

  if (loading) {
    return (
      <div className="bp-skeleton">
        <style>{styles}</style>
        <div className="bp-skeleton-inner">
          <div className="bp-skeleton-title"></div>
          <div className="bp-skeleton-card"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bp-root">
      <style>{styles}</style>
      <div className="bp-container">
        <div className="bp-header">
          <button
            onClick={() => navigate(-1)}
            className="bp-back-btn"
          >
            <FiArrowLeft />
          </button>
          <div className="bp-header-content">
            <h1 className="bp-title">Your Cart</h1>
            <p className="bp-subtitle">
              Review your selected products and complete your purchase
            </p>
          </div>
        </div>

        {error && (
          <div className="bp-alert-error">
            <FiAlertCircle size={24} />
            <p>{error}</p>
          </div>
        )}

        {success && (
          <div className="bp-alert-success">
            <FiCheck size={24} />
            <p>{success}</p>
          </div>
        )}

        {cartItems.length === 0 ? (
          <div className="bp-empty">
            <FiShoppingCart className="bp-empty-icon" size={64} />
            <h3 className="bp-empty-title">Your cart is empty</h3>
            <p className="bp-empty-text">Add products from the product page to start shopping</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="bp-empty-btn"
            >
              Browse Products
            </button>
          </div>
        ) : (
          <div className="bp-cart-grid">
            <div className="bp-items">
              {cartItems.map(item => {
                const product = products.find(p => p._id === item.productId);
                if (!product) return null;
                return (
                  <div key={item.productId} className="bp-item">
                    {product.images && product.images.length > 0 && (
                      <img src={product.images[0]} alt={product.name} className="bp-item-image" />
                    )}
                    <div className="bp-item-info">
                      <h4 className="bp-item-name">{product.name}</h4>
                      <p className="bp-item-price">SP: ₹{(product.sp || 0).toLocaleString("en-IN")}</p>
                      <p className="bp-item-pv">PV: {product.pv || 0}</p>
                    </div>
                    <div className="bp-item-qty">
                      <button
                        onClick={() => updateQuantity(item.productId, item.quantity - 1)}
                        className="bp-qty-btn"
                      >
                        −
                      </button>
                      <span className="bp-qty-value">{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.productId, item.quantity + 1)}
                        className="bp-qty-btn"
                      >
                        +
                      </button>
                    </div>
                    <div className="bp-item-total">
                      <p className="bp-item-total-price">₹{((product.sp || 0) * item.quantity).toLocaleString("en-IN")}</p>
                    </div>
                    <button
                      onClick={() => removeFromCart(item.productId)}
                      className="bp-item-remove"
                    >
                      Remove
                    </button>
                  </div>
                );
              })}
            </div>

            <div className="bp-panel">
              <h3 className="bp-panel-title">Order Summary</h3>
              
              <div className="bp-summary">
                <div className="bp-summary-row">
                  <span className="bp-summary-label">Total MRP</span>
                  <span className="bp-summary-value">₹{cartItems.reduce((sum, item) => {
                    const product = products.find(p => p._id === item.productId);
                    return sum + (product?.mrp || 0) * item.quantity;
                  }, 0).toLocaleString("en-IN")}</span>
                </div>
                <div className="bp-summary-row">
                  <span className="bp-summary-label">Total SP</span>
                  <span className="bp-summary-value-blue">₹{getCartTotal(products).toLocaleString("en-IN")}</span>
                </div>
                <div className="bp-summary-row">
                  <span className="bp-summary-label">Total PV</span>
                  <span className="bp-summary-value-purple">{getCartPv(products)}</span>
                </div>
                <div className="bp-summary-row">
                  <span className="bp-summary-label">Items</span>
                  <span className="bp-summary-value">{cartItems.reduce((sum, item) => sum + item.quantity, 0)}</span>
                </div>
              </div>

              <div className="bp-total-box">
                <div className="bp-total-box-content">
                  <div>
                    <p className="bp-total-label">Total Amount</p>
                    <p className="bp-total-amount">₹{getCartTotal(products).toLocaleString("en-IN")}</p>
                  </div>
                  <div className="bp-total-pv">
                    <p className="bp-total-pv-label">Total PV</p>
                    <p className="bp-total-pv-value">{getCartPv(products)}</p>
                  </div>
                </div>
              </div>

              <div className="bp-form-group">
                <label className="bp-form-label">Select Mobile Store</label>
                <select
                  value={selectedMobileStore}
                  onChange={(e) => setSelectedMobileStore(e.target.value)}
                  className="bp-form-select"
                >
                  <option value="">Choose a store...</option>
                  {mobileStores.map(store => (
                    <option key={store._id} value={store._id}>
                      {store.shopName} - {store.shopAddress}
                    </option>
                  ))}
                </select>
              </div>

              <div className="bp-form-group">
                <label className="bp-form-label">Delivery Address</label>
                <textarea
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                  className="bp-form-textarea"
                  rows="4"
                  placeholder="Enter delivery address"
                />
              </div>

              <div className="bp-form-group">
                <label className="bp-form-label">Contact Number</label>
                <input
                  type="text"
                  value={deliveryContact}
                  onChange={(e) => setDeliveryContact(e.target.value)}
                  className="bp-form-input"
                  placeholder="Enter contact number"
                />
              </div>

              <div className="bp-form-group">
                <label className="bp-form-label">Delivery Notes (Optional)</label>
                <textarea
                  value={deliveryNotes}
                  onChange={(e) => setDeliveryNotes(e.target.value)}
                  className="bp-form-textarea"
                  rows="2"
                  placeholder="Any special instructions for delivery"
                />
              </div>

              <div className="bp-actions">
                <button
                  onClick={clearCart}
                  className="bp-btn-clear"
                >
                  Clear Cart
                </button>
                <button
                  onClick={handlePurchase}
                  disabled={purchasing}
                  className="bp-btn-order"
                >
                  <FiShoppingCart size={20} />
                  {purchasing ? "Processing..." : `Place Order (${cartItems.length} item${cartItems.length > 1 ? 's' : ''})`}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BuyProduct;